import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import enquireJs from 'enquire.js';
import Vue from 'vue';
export function isDef(v) {
  return v !== undefined && v !== null;
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || time == null) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
export function genIdFn() {
  var preKey = "".concat(+new Date());
  var key = 0;
  return function () {
    var curTimestamp = "".concat(+new Date());
    if (curTimestamp === preKey) {
      key += 1;
    } else {
      // 重置 key
      key = 0;
    }
    preKey = curTimestamp;
    return parseInt(preKey + key);
  };
}

/**
 * Remove an item from an array.
 */
export function remove(arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
}
export var autoprefixer = function autoprefixer(style) {
  if (_typeof(style) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};
export function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]';
}
export function enquireScreen(call) {
  var handler = {
    match: function match() {
      call && call(true);
    },
    unmatch: function unmatch() {
      call && call(false);
    }
  };
  enquireJs.register('only screen and (max-width: 767.99px)', handler);
}
export function formatMoney(number, places, symbolL, symbolR, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbolL = symbolL !== undefined ? symbolL : "";
  symbolR = symbolR !== undefined ? symbolR : "";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbolL + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "" + symbolR);
}
var _toString = Object.prototype.toString;

/**
 *	节流
 * @param {function} fn 处理函数
 * @param {Number} interval 延时时间 单位毫秒
 * @returns
 */
export var throttle = function throttle(fn, interval) {
  var firstTime = true,
    _timer,
    _self = fn;
  return function () {
    var _args = arguments,
      _me = this;
    if (firstTime) {
      _self.apply(_me, _args);
      return firstTime = false;
    }
    if (_timer) {
      return false;
    }
    _timer = setTimeout(function () {
      clearTimeout(_timer);
      _timer = null;
      fn.apply(_self, _args);
    }, interval || 300);
  };
};
export function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}
export var kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};
export var isFirefox = function isFirefox() {
  return !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

// 千分位数字
// 12345678 => 12,345,678
// 1234568923 223892892323 => 1,234,568,923 223,892,892,323
export function formatNumber(num) {
  num = num + '';
  return num.replace(/(?!\b)(?=(\d{3})+\b)/g, ',');
}
export function copy(text) {
  if ('clipboard' in navigator) {
    return navigator.clipboard.writeText(text);
  }
  var input = document.createElement('input');
  input.style.opacity = 0;
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}
export function handleLanguage(interfaceData) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var langList = JSON.parse(localStorage.getItem("langList"));
  // let defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
  var langData = [];
  langList.forEach(function (item) {
    var obj = {};
    obj.langId = item.langId;
    obj.content = '';
    obj.languageName = item.langName;
    // if(defaultLangObj.langId = item.langId) {
    //   obj.required = true
    // }
    langData.push(obj);
  });
  langData.forEach(function (item) {
    interfaceData.forEach(function (item2) {
      if (item2.langId == item.langId) {
        if (format) {
          item.content = format(item2.content);
        } else {
          item.content = item2.content;
        }
      }
    });
  });
  return langData;
}